export interface PromotionData {
    promotions: Promotion[] | undefined;
}

export interface Promotion {
    transformedProperties: TransformedProperties | undefined;
    headline: string | undefined;
    subHeadline: string | undefined;
    bodytext: string | undefined;
    linkUrl: string | undefined;
    linkLabel: string | undefined;
    teaser: string | undefined;
    campaign: campaignTitle | undefined;
}

interface TransformedProperties {
    image: PromotionImage | undefined;
}

interface campaignTitle {
    title: string | undefined;
}

export interface PromotionImage {
    "2880x1356": string | undefined;
    "2048x964": string | undefined;
    "1440x678": string | undefined;
    "1134x532": string | undefined;
    "1024x482": string | undefined;
    "567x266": string | undefined;
}

export interface PromotionWithTracking extends Promotion {
    tracking: Tracking;
}

export interface Tracking {
    id: string | undefined;
    name: string | undefined;
    position: string;
}
